export enum LoadState {
  NotLoaded = 0,
  InProgress = 1,
  Loaded = 2,
  Failed = 3,
}

export enum SaveState {
  NotStarted = 0,
  Progress = 1,
  Saved = 2,
}

export enum USER_ROLES {
  ADMIN = 1,
  CSR = 2,
  PRODUCER = 3,
  MARKETER = 4,
  BRANCH_MANAGER = 5,
}

export enum TEMPLATE_RELATED_MODULE_ID {
  LEAD = "LEAD",
  G4SIGN = "G4SIGN",
  TASK = "TASK",
}

export enum TASK_SUBTYPE {
  VEHICLE_CHANGE = "Vehicle Change",
  DRIVER_CHANGE = "Driver Change",
  COVERAGE_CHANGE = "Coverage Change",
  GARAGE_PLATE_CHANGE = "Garage Plate Change",
  INTERESTED_PARTY_CHANGE = "Interested Party Change",
  LESSOR_CHANGE = "Lessor Change",
  ADDRESS_CHANGE = "Address Change",
  RISK_LOCATION_CHANGE = "Risk Location Change",
  CANCELLATION_REINSTALLMENT = "Cancellation/Reinstatement",
  BUSINESS_SUBMISSION = "Business Submission",
  GENERAL_CHANGE = "General Change",
  PAYMENT_AUTH_CHANGE = "Payment Authorization Change",
  LAO_BOR = "LOA/BOR",
  LETTER_OF_EXPERIENCE = "Letter of Experience",

  NEW_BUSINESS = "Business",
  NEW_PERSONAL_AUTO = "Personal Auto",
  NEW_HOME = "Home",
  NEW_COMMERCIAL_AUTO = "Commercial Auto",
  NEW_PERSONAL_AND_HOME = "Personal Auto & Home",
  REMARKET_COMMERCIAL_AUTO = "Commercial Auto",
  REMARKET_HOME = "Home",
  REMARKET_BUSINESS = "Business",
  REMARKET_PERSONAL_AUTO = "Personal Auto",
  REMARKET_PERSONAL_AND_HOME = "Personal Auto & Home",
  QUOTE_REQUEST = "Quote Request",
  TASK_CERTIFICATE_OF_INSURANCE = "Certificate of Insurance",
}

export enum POLICIES {
  BUSINESS_POLICY = "Business Policy",
  AUTOMOBILE_POLICY = "Automobile Policy",
  HABITATIONAL_POLICY = "Habitational Policy",
  COMMERCIAL_AUTO_POLICY = "Commercial Auto Policy",
  LIFE_AND_FINCANCIAL_POLICY = "Life & Financial Policy",
}

export enum POLICIES_NAMES {
  BUSINESS_POLICY = "Business",
  AUTOMOBILE_POLICY = "Automobile",
  HABITATIONAL_POLICY = "Habitational",
  COMMERCIAL_AUTO_POLICY = "Commercial Auto",
  LIFE_AND_FINCANCIAL_POLICY = "Life & Financial",
}

export enum ERROR_MESSAGES {
  "NO_RECORD_FOUND" = "Unfortunately, there are no records available at the moment.",
  "SERVER_ERROR" = "Someting went to be wrong!",
  "POLICY_NOT_FOUND" = "Oops! We couldn't find any records at the moment. Please ensure that the provided information is accurate and try again.",
}

export enum MODULE_IDS {
  TASK = "latest_tasks",
  LEADS = "latest_leads",
  OPPORTUNITY = "latest_opportunity",
  CUSTOMER = "latest_customer_personal_information",
  USER = "latest_user",
  ROLE = "change_role",
  SECURITY = "role_module",
  BRANCH = "latest_branch",
  ZONE = "zone",
  PAYMENT_TRANSACTION = "latest_payment_transaction",
}

export enum TRANSACTION_TYPE_ENUM {
  AuditPlus = "+ Audit",
  AuditMinus = "- Audit",
  Tax = "Tax",
  Reinstate = "Reinstate",
  Reissue = "Reissue",
  Rewrite = "Re-write",
  Correction = "Correction",
  Cancellation = "Cancellation",
  EndorsementPlus = "+ Endorsement",
  EndorsementMinus = "- Endorsement",
  Renewal = "Renewal",
  New = "New",
  FeeNSFFee = "Fee - NSF Fee",
  FeeServiceFee = "Fee - Service Fee",
  FeeInsuranceReports = "Fee - Insurance Reports",
  FeeFacilityFee = "Fee - Facility Fee",
  FeeMGAInsurerFee = "Fee - MGA/Insurer Fee",
  Payment = "Payment",
}

export enum MODULE_NAMES {
  LEADS = "Leads",
  OPPORTUNITY = "Opportunity",
  CUSTOMER = "Customers",
  POLICIES = "Policies",
  LEGALS = "Legals",
  USER = "Users",
  ROLE = "Roles",
  SECURITY = "Security",
  PAYMENT_TRANSACTION = "Payment Transaction",
}

export enum ALLOWED_MODULES {
  DASHBOARD = "DASHBOARD|DASHBOARD|",
  UPSELLING_DASHBOARD = "DASHBOARD|UPSELLING DASHBOARD|",
  UPSELL_INSIGNTS = "INSIGHT|UPSELLING INSIGHT|LATEST_UPSELLING_INSIGHT",
  SECURITY = "SECURITY|SECURITY|ROLE_MODULE",
  ROLE_GROUPS = "SECURITY|ROLE GROUPS|LATEST_ROLE_GROUPS",
  LEADS = "LEADS|LEADS|LATEST_LEADS",
  CHATS = "ORGANIZATION SETTINGS|CHATS|LATEST_CONVERSATION_WHATSAPP",
  REVIEW = "REVIEW|REVIEW|LATEST_GOOGLE_REVIEWS",
  VENUE = "VENUE|VENUE|LATEST_VENUE",
  BOOKING = "OCCUPANCY|BOOKING|LATEST_BOOKING",
  CUSTOMER = "CUSTOMER|CUSTOMER|CUSTOMER_FACT",
  TEMPLATES = "TEMPLATE|TEMPLATE|LATEST_TEMPLATES",
  USERS = "ORGANIZATION SETTINGS|USERS|LATEST_USER",
  USERS_ENR = "USERS|USERS|LATEST_USER",
  ROLES = "latest_roles",
  MANAGE_SITE = "ADMIN_MANAGE SITE_LATEST_MANAGE_SITE",
  USER_BRANCH = "DATA MANAGEMENT|BRANCH|LATEST_BRANCH",
  ZONE = "DATA MANAGEMENT|ZONE|LATEST_ZONE",
  ENV_CONFIG = "MANAGE ENVIRONMENT CONFIGURATION|MANAGE ENVIRONMENT CONFIGURATION|LATEST_ENVIRONMENT_CONFIGURATION",
  COMPANY_OUTLET_ENV_CONFIG = "COMPANY OUTLET|COMPANY OUTLET ENVIRONMENT|LATEST_COMPANY_OUTLET_ENV",
  COMPANY_OUTLET_LOGO = "COMPANY OUTLET LOGO|COMPANY OUTLET LOGO|LATEST_COMPANY_OUTLET",
  COMPANY_OUTLET = "COMPANY OUTLET|COMPANY OUTLET|LATEST_COMPANY_OUTLET",
  PAYMENT_DETAILS_GROUP_BY_LEADS = "ACCOUNTING|PAYMENT TRANSACTION GROUP BY LEADS|LATEST_PAYMENT_TRANSACTION_GROUP_BY_LEADS",
  PAYMENT_TRANSACTION = "ACCOUNTING|PAYMENT TRANSACTION|LATEST_PAYMENT_TRANSACTION",
  MARKETING = "MARKET CAMPAIGN|MARKET CAMPAIGN|LATEST_MARKET_CAMPAIGN",
  CHANGE_ROLE = "USERS|CHANGE ROLE|CHANGE_ROLE",
  WHATSAPP_QR = "ORGANIZATION SETTINGS|WHATSAPP QR|",
  STATUS_LIFE_CYCLE = "ORGANIZATION SETTINGS|STATUS LIFE CYCLE|LATEST_STATUS",
  CUSTOM_CANCELLATION_REASON = "ORGANIZATION SETTINGS|CUSTOM CANCELLATION REASONS|LATEST_CANCELLATION_REASON",
  MASTER_STATUS = "ENR SETTINGS|MASTER STATUS|LATEST_MASTER_STATUS",
  COMPANY_INFORMATION = "ENR SETTINGS|COMPANY INFORMATION|LATEST_COMPANY_INFORMATION",
  AUTOMATION = "ENR SETTINGS|AUTOMATION|LATEST_WORKFLOW_BASIC",
  ENR_CANCEL_REASON = "ENR SETTINGS|ENR CANCELLATION REASON|LATEST_MASTER_CANCELLATION_REASON",
  META_TEMPLATE = "TEMPLATE|META TEMPLATE|",
  EXOLET_TEMPLATE = "TEMPLATE|EXOTEL TEMPLATE|",
  SUBSCRIPTION = "SUBSCRIPTION|SUBSCRIPTION PLAN|LATEST_SUBSCRIPTION_PLAN",
  SUBSCRIPTION_PLAN = "SUBSCRIPTION|SUBSCRIPTION PLAN FEATURE|LATEST_SUBSCRIPTION_PLAN_FEATURE",
  MASTER_MENU = "FOOD|MASTER MENU|LATEST_MASTER_MENU",
  FOOD_ITEMS = "FOOD|FOOD ITEMS|LATEST_FOOD_ITEM",
  FOOD_CATEGORIES = "FOOD|FOOD CATEGORIES|LATEST_CATEGORY",
  FOOD = "FOOD|MASTER MENU|LATEST_MASTER_MENU",
  ORG_ENV_CONFIG = "ORGANIZATION SETTINGS|ORGANIZATION ENVIRONMENT CONFIGURATION|LATEST_COMPANY_OUTLET_ENV",
  SERVICE_CATEGORY = "SERVICE|SERVICE CATEGORY|LATEST_SERVICE_CATEGORY",
  SERVICE_ITEM = "SERVICE|SERVICE ITEM|LATEST_SERVICE_ITEM",
  EVENT = "EVENT|EVENT|LATEST_EVENT",
  MASTER_FORM = "ENR SETTINGS|MASTER FORM|LATEST_MASTER_FORM",
  FORM = "DATA MANAGEMENT|FORM|LATEST_FORM",
  GENAI_PROMPT = "ENR SETTINGS|GENAI PROMPT|LATEST_GENAI_PROMPT",
  GENAI_CONTEXT = "ENR SETTINGS|GENAI CONTEXT|LATEST_GENAI_CONTEXT",
  RESTRICTED_WORDS = "ORGANIZATION SETTINGS|RESTRICTED WORDS|LATEST_RESTRICTED_WORDS",

  ENR_SUPPORT = "ENR SUPPORT|ENR SUPPORT|LATEST_SUPPORT_TICKETS",
  COMPANY_OUTLET_SUBSCRIPTION = "COMPANY OUTLET|COMPANY OUTLET SUBSCRIPTION|LATEST_COMPANY_OUTLET_SUBSCRIPTION",
  DYNAMIC_FORMS = "ORGANIZATION SETTINGS|DYNAMIC FORMS|LATEST_FORMS",
  DELETED_LEADS= "ORGANIZATION SETTINGS|DELETED LEADS|LATEST_LEADS"
}

export enum MODULES_UUIDS {
  LEADS = "4f6889ec-dd76-465f-bd25-b4c2c0f5d436",
  USERS = "de415b9c-5139-4af5-adfa-8a79f2ee87bd",
}
